<template>
    <templatePublicComponent>
        <div>
            <h3>F.A.Q. :</h3>
            <div class="content">
                <h4>Guide de déneigement</h4>
                <table align="center" border="0" class="faqTab">
                    <tbody>
                        <tr>
                          <td><img class="faqImg" alt="" src="@/assets/img/guide-deneigement_04.jpg"></td>
                          <td><img class="faqImg" alt="" src="@/assets/img/guide-deneigement_06.jpg"></td>
                        </tr>
                        <tr>
                          <td><img class="faqImg" alt="" src="@/assets/img/guide-deneigement_08.jpg"></td>
                          <td><img class="faqImg" alt="" src="@/assets/img/guide-deneigement_07.jpg"></td>

                        </tr>
                        <tr>
                          <td><img class="faqImg" alt="" src="@/assets/img/guide-deneigement_11.jpg"></td>
                          <td><img class="faqImg" alt="" src="@/assets/img/guide-deneigement_10.jpg"></td>
                        </tr>
                        <tr>
                          <td><img class="faqImg" alt="" src="@/assets/img/guide-deneigement_09.jpg"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </templatePublicComponent>
</template>

<script>
import FrameComponent from '../components/Frame.vue'
import TemplatePublicComponent from '../components/TemplatePublic.vue'
export default {
  components:
  {
    FrameComponent,
    TemplatePublicComponent
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Faq.vue